import React from "react";

import styles from "./styles.module.scss";

const Category = () => {
  return (
    <div className={styles.category__wrapper}>
      <h1>Categories I promote</h1>
      <div className={styles.list}>
        <span className={styles.tag}>Online Events</span>
        <span className={styles.tag}>Dancing Events</span>
        <span className={styles.tag}>Live Music Concert Events</span>
        <span className={`${styles.tag} ${styles.bg}`}>Add</span>
      </div>
    </div>
  );
};

export default Category;
